import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import GiphyEmojiButtons from '../../../shared/_TBComponents/GiphyEmojiButtons';
import { uploadCommentMediaUrl } from '../ducks/journalActions';
import { journalTracker } from '../../../shared/utils/amplitudeHelper';

const JournalGiphyEmoji = ({
  commentId,
  entryId,
  newCommentText,
  setNewCommentText,
}) => {
  const dispatch = useDispatch();

  const handleSelectGif = useCallback((gifUrl) => {
    dispatch(uploadCommentMediaUrl({ mediaUrl: gifUrl }, entryId, commentId));
    journalTracker('Journal entry comment', 'Media uploaded - GIF');
  }, [dispatch, entryId, commentId]);

  const handleSelectEmoji = useCallback((emoji) => {
    setNewCommentText(newCommentText.concat(emoji.native));
  }, [newCommentText, setNewCommentText]);

  return (
    <GiphyEmojiButtons
      onSelectGif={handleSelectGif}
      onSelectEmoji={handleSelectEmoji}
      alignRight
    />
  );
};

JournalGiphyEmoji.propTypes = {
  commentId: PropTypes.number,
  entryId: PropTypes.number.isRequired,
  newCommentText: PropTypes.string.isRequired,
  setNewCommentText: PropTypes.func.isRequired,
};

JournalGiphyEmoji.defaultProps = {
  commentId: null,
};

export default JournalGiphyEmoji;
